export const education = [{}, {}, {}, {}, {}, {}];
